import Browser from '@parameter1/base-cms-marko-web/browser';
import Global from '@industrial-media/package-global/browser';

Global(Browser);

export default Browser;
